<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card header="Total Donasi Sesuai Funding">
          <div v-if="isLoading"> 
            <center>
              <v-pulse></v-pulse>
            </center>
          </div>
          <div v-else class="table-responsive">
            <table class="table table-striped table-bordered table-hover" >
              <thead>
                <tr>
                    <th>No</th>
                    <th>Nama Funding</th>
                    <th>Tanggal Mulai</th>
                    <th>Foto</th>
                    <th>Barang</th>
                </tr>
              </thead>
              <tbody v-if="fundings.length > 0">
                <tr v-for="(value,index) in fundings" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{value.title}}</td>
                    <td>{{value.start_date}}</td>
                    <td>
                      <b-img class="imageFile" thumbnail fluid :src="'https://res.cloudinary.com/wahyupermadie/image/fetch/c_fill,g_auto:face,h_120,w_120,fl_force_strip.progressive/f_webp/https://hackathon.futnet.id/funding/'+value.foto" alt="Thumbnail" />
                    </td>
                    <td v-if="value.barang.length > 0">
                      <ul class="list-group" v-for="(barang,index) in value.barang" :key="index">
                          <li class="list-group-item d-flex justify-content-between align-items-center">
                              {{barang.name}} 
                              <span class="badge badge-primary">{{barang.total}} | {{barang.satuan}}</span>
                          </li>
                      </ul>
                    </td>
                    <td v-else>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            Belum Ada Donasi
                        </li>
                    </td>
                </tr>
              </tbody>
              <tbody v-else>
                  <td colspan="5">
                    <center> Tidak Ada Data </center>
                  </td>
              </tbody>
            </table>
          </div>
        </b-card>
        <b-card header="Daftar Transfer">
          <div v-if="isLoading" > 
            <center>
              <v-pulse></v-pulse>
            </center>
          </div>
          <div  v-else class="table-responsive">
            <table class="table table-striped table-bordered table-hover" >
              <thead>
                <tr>
                    <th>No</th>
                    <th>Jumlah</th>
                    <th>Tanggal</th>
                    <th>Foto</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
              </thead>
              <tbody v-if="transfers.length > 0">
                    <tr v-for="(value,index) in transfers" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{value.jumlah}}</td>
                        <td>{{value.tanggal}}</td>
                        <td>
                            <b-img class="imageFile" thumbnail fluid :src="'https://res.cloudinary.com/wahyupermadie/image/fetch/c_fill,g_auto:face,h_120,w_120,fl_force_strip.progressive/f_webp/https://hackathon.futnet.id/transfer/'+value.foto" alt="Thumbnail" />
                        </td>
                        <td v-if="value.confirm == '0'">
                            <b-badge href="#" variant="danger">Belum Konfirmasi</b-badge>
                        </td>
                        <td v-else>
                            <b-badge href="#" variant="success">Confirmed</b-badge>
                        </td>
                        <td>
                            <button type="button" @click="confirm(value.id)" class="btn btn-xs btn-outline-warning"><span class="fa fa-pencil"></span></button>
                        </td>
                    </tr>
                </tbody>
              <tbody v-else>
                  <td colspan="6">
                    <center> Tidak Ada Data </center>
                  </td>
              </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import {getCache,storedCache} from '@/cache'
import constant from '../../utils/constant.js';
const token = localStorage.getItem(`user_token`);
const community_id = localStorage.getItem('user_id');
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
export default {
  name: 'dashboard',
  data: function () {
    return {
        isLoading: true,
        fundings : [],
        transfers : []
    }
  },
  created: function(){
      const token = localStorage.getItem(`user_token`);
      const community_id = localStorage.getItem('user_id');
      this.getDashboard()
  },
  mounted() {
    
  },
  methods:{
    confirm(id)
    {
      this.$swal({
        title: 'Konfirmasi ',
        text: 'Apakah anda yakin konfimasi pembayaran ini ?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Yes Confirm!',
        cancelButtonText: 'No, Cancel!',
        showCloseButton: true,
        showLoaderOnConfirm: true
        }).then((result) => {
          if(result.value) {
              axios.put(constant._BASE_URL+"payment/"+id,"",{
                headers:{
                    'Content-type': 'application/json',
                    'Authorization' : 'Bearer '+token,
                }
              }).then(response => {
                    let message = response.data.success
                    console.log(message)
                    this.$swal('Konfirmasi', message , 'success')
                    this.getPayments()
              })
          } else {
    
          }
      })
    },
    getDashboard()
    {
        this.openSpinner()
        const token = localStorage.getItem(`user_token`);
        axios.get(constant._BASE_URL+"dashboard",{ 
            headers: {
            'Content-type': 'application/json',
            'Authorization' : 'Bearer '+token,
            }
        }).then(response => {
            storedCache(`dashboard_funding`+community_id, response.data.items)
            storedCache(`dashboard_transfer`+community_id, response.data.transfers)
            this.fundings = getCache(`dashboard_funding`+community_id)
            this.transfers = getCache(`dashboard_transfer`+community_id)
            this.closeSpinner()
        }).catch(error => {
            alert(error)
            this.fundings = getCache(`dashboard_funding`+community_id)
            this.transfers = getCache(`dashboard_transfer`+community_id)
            this.closeSpinner()
        });
    },
    openSpinner()
    {
        this.isLoading = true
    },
    closeSpinner()
    {
       this.isLoading = false
    }
  }
}
</script>

<style scoped>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .imageFile {
    height: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue